import moment from 'moment';
import React from 'react';
import { Table } from '../../../common-components/Table/Table';
import { strings } from '../../../resources/strings';
import { HistoryByOrder } from '../../../services/Orders/GetHistoryByOrder/HistoryByOrder';
import { Container } from './styles';

interface ITabHistoricProps {
    historic?: HistoryByOrder[];
}

export const TabHistoric: React.FC<ITabHistoricProps> = ({
    historic
}) => {

    const items = React.useMemo(() => {
        return (
            <Table>
                <thead>
                    <tr>
                        <th style={{width:'175px', minWidth:'175px'}}>{strings.Date}</th>
                        <th style={{width:'50%'}}>{strings.Description}</th>
                        <th style={{width:'50%'}}>{strings.Details}</th>
                        <th style={{width:'150px', minWidth:'150px'}}>{strings.User}</th>
                    </tr>
                </thead>
                <tbody>
                    {historic?.map((item, itemIndex) => {
                        return (
                            <tr key={`historic-item-${itemIndex}`}>
                                <td>{moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')}</td>
                                <td>{item.stateDescription}</td>
                                <td>{item.details}</td>
                                <td>{item.userName}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }, [ historic ]);

    return (
        <Container>
            {items}
        </Container>
    );
};